import styled from "styled-components"

import Button from "@irati/ui/src/Button"
import {Hr} from "@irati/ui/src/Layout"

interface DropdownOverflowProps {
  color?: string,
  icon?: string,
  id?: string,
  open?: boolean,
  top?: boolean
}

export const RefWrapper = styled.div`
  max-width: max-content;
  max-height: max-content;
`
export const InnerRefWrapper = styled.div`
  z-index: 999;
`

export const ToggleButton = styled(Button)<DropdownOverflowProps>`
  padding: 10px;
  ${({open, theme}) => open && `box-shadow: 0 0 0 1px ${theme.colors.greys.mediumDark};`}
`

export const StyledHr = styled(Hr)<DropdownOverflowProps>`
  margin: ${({top}) => (top ? "10px 0 0 0" : "0 0 10px 0")};
`
